var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5C2 6.614 2 5.672 2.586 5.086C3.172 4.5 4.114 4.5 6 4.5H18C19.886 4.5 20.828 4.5 21.414 5.086C22 5.672 22 6.614 22 8.5C22 8.971 22 9.207 21.854 9.354C21.707 9.5 21.47 9.5 21 9.5H3C2.529 9.5 2.293 9.5 2.146 9.354C2 9.207 2 8.97 2 8.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5V5.5M17 2.5V5.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5C21.47 11.5 21.7065 11.5005 21.8535 11.6465C21.9995 11.7935 22 12.029 22 12.5V17.5C22 19.386 22.0001 20.3281 21.4141 20.9141C20.8281 21.5001 19.886 21.5 18 21.5H6C4.114 21.5 3.17194 21.5001 2.58594 20.9141C1.99994 20.3281 2 19.386 2 17.5V12.5C2 12.03 2.00049 11.7935 2.14648 11.6465C2.29348 11.5005 2.529 11.5 3 11.5H21ZM4 17.5V19.5H8V17.5H4ZM10 17.5V19.5H14V17.5H10ZM16 17.5V19.5H20V17.5H16ZM4 13.5V15.5H8V13.5H4ZM10 13.5V15.5H14V13.5H10ZM16 13.5V15.5H20V13.5H16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar24);
export default __webpack_public_path__ + "static/media/Calendar24.eebc43881d2883335172e1d7690466a3.svg";
export { ForwardRef as ReactComponent };